import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  withCredentials: true,
  headers: { 'Accept': 'application/json' },
});

// CSRF-Token automatisch holen (Laravel Sanctum)
api.interceptors.request.use(async (config) => {
  if (['post', 'put', 'patch', 'delete'].includes(config.method)) {
    await axios.get('/sanctum/csrf-cookie', { withCredentials: true });
  }

  // Aktuelles Projekt automatisch an jeden Request anhängen,
  // außer der Caller hat skipProject: true gesetzt oder den Param schon mitgegeben.
  if (!config.skipProject) {
    try {
      const stored = JSON.parse(localStorage.getItem('ko-project') || '{}');
      const projectId = stored?.state?.currentProjectId;
      if (projectId) {
        config.params = { project: projectId, ...(config.params || {}) };
      }
    } catch {
      // ignore
    }
  }

  return config;
});

// 401 → Auth-Store zurücksetzen
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
